// extracted by mini-css-extract-plugin
export default {"circularLoader":"loader_circularLoader__6BOex","rotate4":"loader_rotate4__F-coB","circularLoaderCircle":"loader_circularLoaderCircle__+6Sb+","dash4":"loader_dash4__MOI0E"};